import { Configuration } from '../../app.constants'
import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'

@Injectable()
export class SelectNgoService {

  constructor(private http: HttpClient) { }

  getCauses(onlyActive = true): any {
    return this.http.get(Configuration.apiUrl + 'api/Ngo/getCauses?onlyActive=' + onlyActive)
  }

  searchNgos(onlyActive, doubleVerified, junoOk, searchTerm, state, category, actualPage, pageSize): any {
    return this.http.get(Configuration.apiUrl + 'api/Ngo/CombinedSearchNgos?onlyActive=' + onlyActive + '&doubleVerified=' + doubleVerified + '&junoOk=' + junoOk + '&searchTerm=' + searchTerm + '&state=' + state + '&category=' + category + '&page=' + actualPage + '&pageSize=' + pageSize)
  }

}
